module.exports = __webpack_public_path__ + "static/media/popRocks.748b1b0e.png";